import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const F = ({ label, children }) => <div><Label className="text-[10px] tracking-widest uppercase opacity-70">{label}</Label><div className="mt-1">{children}</div></div>;

export function RequestAccessDialog({ open, onClose }) {
  const [f, setF] = useState({ name: "", email: "", phone: "", team_or_role: "", message: "", website: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k, v) => setF(s => ({ ...s, [k]: v }));
  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim() || !f.email.trim() || !f.team_or_role.trim()) { toast.error("Name, email and your team/role are required"); return; }
    setBusy(true);
    try { await api.post("/access-requests", { ...f, phone: f.phone || null, message: f.message || null }); setDone(true); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Couldn't send — please try again"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md bg-[#0A0F1C] text-white border-white/10" data-testid="request-access-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight text-2xl">Message support</DialogTitle>
          <DialogDescription className="text-white/60">Tell us who you are and a club admin will set up your account.</DialogDescription>
        </DialogHeader>
        {done ? (
          <div className="space-y-4" data-testid="request-access-done">
            <div className="rounded border border-[#83B68B]/40 bg-[#83B68B]/10 p-4 text-sm">Thanks {f.name.split(" ")[0]} — your request is with the club admins. You'll get a welcome email at <strong>{f.email}</strong> once your account is ready.</div>
            <button type="button" onClick={onClose} data-testid="request-access-close" className="w-full py-2.5 rounded border border-white/20 text-[10px] tracking-widest uppercase">Back to sign in</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <F label="Your name"><Input value={f.name} onChange={e => set("name", e.target.value)} data-testid="request-access-name" className="bg-white/5 border-white/15" /></F>
            <F label="Email"><Input type="email" value={f.email} onChange={e => set("email", e.target.value)} data-testid="request-access-email" className="bg-white/5 border-white/15" /></F>
            <F label="Mobile (optional)"><Input value={f.phone} onChange={e => set("phone", e.target.value)} data-testid="request-access-phone" className="bg-white/5 border-white/15" /></F>
            <F label="Team / role at the club"><Input value={f.team_or_role} onChange={e => set("team_or_role", e.target.value)} placeholder="e.g. U9 Aylett coach, parent helper, referee" data-testid="request-access-role" className="bg-white/5 border-white/15" /></F>
            <F label="Anything else (optional)"><Textarea rows={3} value={f.message} onChange={e => set("message", e.target.value)} data-testid="request-access-message" className="bg-white/5 border-white/15" /></F>
            <input type="text" value={f.website} onChange={e => set("website", e.target.value)} tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" />
            <button type="submit" disabled={busy} data-testid="request-access-submit" className="w-full btn-volt py-3 rounded text-[10px] tracking-widest uppercase disabled:opacity-40">{busy ? "Sending…" : "Send request"}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
